import React, { useEffect, useMemo, useRef, useState } from "react";
import Dashboard from "asset-metrics-dashboard";
import assetMetricsCmmsDataProvider from "../../dataProviders/assetMetricsCmmsDataProvider";

// Read configuration from environment variables
const apiKey = process.env.REACT_APP_LCCENGINE_API_KEY || '';
const metricsApiBase = process.env.REACT_APP_LCCENGINE_API_BASE || '';

const UtilisationDashboardLayer = () => {
  const dataProvider = useMemo(() => assetMetricsCmmsDataProvider, []);
  const autoApplyDoneRef = useRef(false);
  const suppressInitialMeterErrorRef = useRef(true);
  const [hideInitialMeterError, setHideInitialMeterError] = useState(true);

  useEffect(() => {
    const suppressTimeoutId = setTimeout(() => {
      suppressInitialMeterErrorRef.current = false;
      setHideInitialMeterError(false);
    }, 2500);

    return () => clearTimeout(suppressTimeoutId);
  }, []);

  useEffect(() => {
    if (autoApplyDoneRef.current) return;

    const tryAutoApply = () => {
      if (autoApplyDoneRef.current) return true;

      const meterLabel = Array.from(document.querySelectorAll("label")).find(
        (label) => label.textContent?.trim() === "Meter"
      );
      const meterSelect = meterLabel?.parentElement?.querySelector("select");
      const applyButton = Array.from(
        document.querySelectorAll("button.btn.btn-primary")
      ).find((button) => button.textContent?.trim() === "Apply");

      if (!meterSelect || !applyButton) return false;
      if (!meterSelect.value || applyButton.disabled) return false;

      applyButton.click();
      autoApplyDoneRef.current = true;
      return true;
    };

    if (tryAutoApply()) return;

    const intervalId = setInterval(() => {
      if (tryAutoApply()) {
        clearInterval(intervalId);
      }
    }, 200);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className='row gy-4 p-24'>
      <style>
        {`
          .utilisation-dashboard-metrics .card .card-body h3 {
            font-size: 1.75rem !important;
          }
          .utilisation-dashboard-metrics span.badge.rounded-pill.bg-secondary-focus {
          color: #1f2937 !important;
          background-color: #e5e7eb !important;}
          .utilisation-dashboard-metrics .apexcharts-canvas {
          background-color: #ffffff !important;
          }
        `}
      </style>
      <div className={`utilisation-dashboard-metrics${hideInitialMeterError ? " hide-initial-meter-error" : ""}`}>
        <Dashboard
          dataProvider={dataProvider}
          visibleKpis={["utilisation", "calendarUtilisation", "mechanicalAvailability", "calendarAvailability"]}
/*
            "stoppageCountTotal", "stoppageCountTotal", "stoppageCountBreakdown", "stoppageHoursTotal",
            "stoppageHoursBreakdown", "percentageBreakdownEvents", "stoppagesPerThousandHours", "meanTimeBetweenStoppages",
            "meanTimeBetweenFailures", "meanTimeToFirstStoppageAfterPm", "meanTimeBetweenUnplannedStoppages",
            "availabilityIndex" 
*/
          apiKey={apiKey}
          metricsApiBase={metricsApiBase}
          showSettings={false}
          onError={(message) => {
            if (
              suppressInitialMeterErrorRef.current &&
              message === "Select a meter to view metrics."
            ) {
              return;
            }
            console.error(message);
          }}
        />
      </div>
    </div>
  );
};

export default UtilisationDashboardLayer;
